import DevelopmentDetailLayout from '../../components/DevelopmentDetailLayout';

function SouthlandsHouse() {
  return (
    <DevelopmentDetailLayout
      title="Southlands Care Village"
      metaDescription="Southlands Care Village, Sittingbourne — a landmark Graham Care development with 74 care suites, under construction since May 2025 with completion expected March 2027."
      tagline="Building for the Future of Elderly Care"
      subtitle="Construction commenced: May 2025 | Estimated completion: March 2027"
    >
      <p>
        We are delighted to share that construction is now well under way at Southlands Care Village — a landmark new
        development in Bobbing, Sittingbourne. After years of careful planning, community consultation, and preparatory
        works, ground was broken in May 2025, and we anticipate welcoming our first residents by March 2027.
      </p>

      <h3>About the Development</h3>
      <p>
        Southlands Care Village will replace a long-vacant 1990s care facility on a 1.57-hectare site, formerly part of
        Keycol Hospital. Planning approval was granted by Swale Borough Council on 25 April 2019, following two rounds
        of public consultation and engagement with the local Parish Council. The scheme has been shaped at every stage
        by community feedback and a commitment to respecting its surroundings.
      </p>
      <p>
        The result is a purpose-built care home providing 74 high-quality care suites, designed to support residents
        with a wide range of needs — including dementia and complex medical conditions. The two-and-a-half storey layout
        minimises visual impact on neighbouring properties while maximising garden space and countryside views.
      </p>

      <h3>Exceptional Care Suites</h3>
      <p>Each of the 74 spacious care suites (minimum 26m²) includes:</p>
      <ul>
        <li>A private en-suite wet room</li>
        <li>A dedicated social and dining area for family visits</li>
        <li>A kitchenette for independence and convenience</li>
        <li>Patio access or generous windows for light and views</li>
      </ul>
      <p>
        The building is designed around a central hub with communal lounges, dining areas, and garden access —
        promoting easy navigation, safety, and social connection. Specialist amenities include a cinema, treatment
        rooms, a hair salon, and a purpose-built Day Care Centre for up to 20 additional users from the wider
        community.
      </p>

      <h3>Designed for Wellbeing and Safety</h3>
      <p>Residents will benefit from:</p>
      <ul>
        <li>Piped oxygen to every suite</li>
        <li>Advanced real-time monitoring systems</li>
        <li>24/7 dedicated nursing care</li>
        <li>Dementia-friendly design features throughout</li>
        <li>Secure, accessible landscaped gardens with wandering paths</li>
      </ul>
      <p>
        Wide corridors, recessed entryways, lifts to all floors, and 50 parking spaces ensure ease of access for
        residents, families, and staff alike.
      </p>

      <h3>Sustainable, Community-Centred Design</h3>
      <p>
        The architecture blends traditional materials — brick, render, and timber — with contemporary, energy-conscious
        design. Former brownfield areas at the front of the site will be transformed into a community green space,
        enhancing local biodiversity and providing an attractive open area for the neighbourhood.
      </p>

      <h3>A Vision Worth the Wait</h3>
      <p>
        Southlands Care Village represents a significant and long-term investment in elderly care for the district. By
        combining medical excellence, thoughtful design, and genuine community integration, the development will address a
        growing and clearly identified local need — and we look forward to sharing further updates as construction
        progresses.
      </p>
    </DevelopmentDetailLayout>
  );
}

export default SouthlandsHouse;
